const state = {
  gameMode: null,
  level: 0,
}

const getters = {
  gameMode : state => state.gameMode,
  level: state => state.level,
}

const mutations = {
  setGameMode(state, payload){
    state.gameMode = payload;
  },
  levelUp(state){
    if (state.gameMode=='complements') {
      if (state.level<1) {
        state.level +=1;
      }
    }
    else if(state.gameMode=='readSoroban' || state.gameMode=='moveSoroban'){
      if (state.level<2) {
        state.level +=1;
      }
    }
    else{
      if (state.level<5) {
        state.level +=1;
      }
    }
  },
  levelDown(state){
    if (state.level>0) {
      state.level -=1;
    }

  },
  setLevel(state,payload){
    state.level=payload
  }

}

const actions = {
  setGameMode({commit},payload){
    commit('setGameMode',payload)
  },
  levelUp({commit}){
    commit('levelUp')
  },
  levelDown({commit}){
    commit('levelDown')
  },
  setLevel({commit}, payload){
    commit('setLevel', payload)
  }

}

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true,
}
